import { render, staticRenderFns } from "./seriesImage.vue?vue&type=template&id=5dab1db0&scoped=true&"
import script from "./seriesImage.vue?vue&type=script&lang=js&"
export * from "./seriesImage.vue?vue&type=script&lang=js&"
import style0 from "./seriesImage.vue?vue&type=style&index=0&id=5dab1db0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dab1db0",
  null
  
)

component.options.__file = "seriesImage.vue"
export default component.exports